// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1d914","list":"BalanceDue_list__iPagg","listRow":"BalanceDue_listRow__3DqSF","total":"BalanceDue_total__JdSbJ"};